import Alpine from 'alpinejs'
import header from '@/components/header.js'
import video from '@/components/video.js'
import accordion from '@/components/accordion.js'
import embedVideo from '@/components/embed/video.js'
import gallery from '@/components/gallery.js'
import countdown from '@/components/countdown.js'
import lineup from '@/components/lineup.js'
import timeline from '@/components/timeline.js'
import frontPageVideo from '@/components/front-page-video.js'
import marquee from '@/components/marquee.js'
import modal from '@/components/modal.js'
import modalAge from '@/components/modal-age.js'
import scrollspy from '@/components/scrollspy.js'
import photoGallery from '@/components/photo-gallery.js'
import lineupHistory from '@/components/lineupHistory.js'

//
// Polyfills
//
import 'scrollyfills'

//
// Fonts
//
import '@fontsource/bebas-neue'
import '@fontsource/roboto'

//
// Styles
//
import '../css/style.css'

//
// Setup Alpine
//
window.Alpine = Alpine

//
// Setup Alpine components
//
Alpine.data('header', header)
Alpine.data('video', video)
Alpine.data('accordion', accordion)
Alpine.data('embedVideo', embedVideo)
Alpine.data('gallery', gallery)
Alpine.data('countdown', countdown)
Alpine.data('lineup', lineup)
Alpine.data('timeline', timeline)
Alpine.data('frontPageVideo', frontPageVideo)
Alpine.data('marquee', marquee)
Alpine.data('modal', modal)
Alpine.data('modalAge', modalAge)
Alpine.data('scrollspy', scrollspy)
Alpine.data('photoGallery', photoGallery)
Alpine.data('lineupHistory', lineupHistory)

//
// Initialize Alpine
//
Alpine.start()

//
// Staggered appear animations
//
const staggers = [...document.querySelectorAll('[data-stagger]')]
const triggered = new WeakSet()
const onIntersecting = (target) => {
    const items = [...target.querySelectorAll('[data-appear]')]

    if (triggered.has(target)) {
        return
    }

    triggered.add(target)

    items.forEach((item, index) => {
        const className = item.dataset.appear
        const delay = (parseInt(item.dataset.appearDelay) || 0) + index * 100
        const onAnimationEnd = (event) => {
            event.target.classList.remove(className)
            event.target.removeAttribute('data-appear')
            event.target.removeEventListener('animationend', onAnimationEnd)
        }

        item.addEventListener('animationend', onAnimationEnd)
        item.style.animationDelay = `${delay}ms`
        item.classList.add(className)
    })
}
const observer = !!window.IntersectionObserver
    ? new IntersectionObserver(
          (entries, observer) => {
              for (const entry of entries) {
                  if (entry.intersectionRatio > 0) {
                      onIntersecting(entry.target)
                      observer.unobserve(entry.target)
                  }
              }
          },
          {
              rootMargin: '0% 0% -20% 0%',
              threshold: 0,
          }
      )
    : null
const endObserver = !!window.IntersectionObserver
    ? new IntersectionObserver(
          (entries, observer) => {
              for (const entry of entries) {
                  if (entry.intersectionRatio > 0) {
                      staggers.forEach(onIntersecting)
                      observer.unobserve(entry.target)
                  }
              }
          },
          {
              rootMargin: '0%',
              threshold: 0,
          }
      )
    : null

staggers.forEach((stagger) => {
    if (observer) {
        observer.observe(stagger)
    } else {
        onIntersecting(stagger)
    }
})

if (endObserver) {
    endObserver.observe(document.querySelector('#scroll-end-trigger'))
}
